import axios from '../../helpers/axiosConfig';
import { Link, useNavigate } from 'react-router-dom';

function Accueildcca() {
  return (
    <div className="container mt-5 pt-5 ">
      <div className="row  form-group">
        <div className="col-md-6 ">
          {/* {{ path('accueil.index') }} */}
          <a className="btn btn-success form-control " href="/dcca">
            DCCA Actus
          </a>
        </div>
        <div className="col-md-6">
          <a className=" btn btn-success form-control " href="/personnel">
            Gestion Personnel Militaire/Civil
          </a>
        </div>
      </div>
      <div className="row form-group ">
        <div className="col-6">
          <a className=" btn btn-success form-control  " href="#">
            DOCS Restructuration
          </a>
        </div>
        <div className="col">
          <a className=" btn btn-success form-control " href="#">
            Services Centraux
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col">
          {/* {{ path('home.orgoper') }} */}
          <a href="# " className=" p-2 btn btn-primary btn-sm col-md-12">
            ADMINISTRATION ET FINANCES DES ARMEES
          </a>
        </div>
      </div>

      <div className="col-md-12 mt-5">
        <div className="row">
          <div className="col bg-info p-4 rounded-lg ">
            ‘’…. La Direction Centrale du Commissariat des Armées est l’unique département ravitailleur et de soutien des armées en matière d’habillement, de couchage, de campement et d’alimentation
            (HCCA). Elle est appelée à satisfaire les besoins de celles-ci grâce aux fonds budgétaires qui lui sont alloués. En sus, elle est, pour le commandement, un organisme de conseils en matière
            administrative, financière, logistique et juridique…. ‘’
          </div>
        </div>
      </div>
    </div>
  );
}

export default Accueildcca;
